export const Product = (product, initialVariant, mainProduct = true) => ({
  product,
  selectedOptions: initialVariant?.options || [],
  quantity: 1,
  activeSlide: 0,
  sliderImages: null,
  get current_variant() {
    return (
      this.product.variants.find((variant) =>
        this.selectedOptions.every((option) => variant.options.includes(option))
      ) || this.product.variants[0]
    );
  },
  get amountSaved() {
    if (
      !this.current_variant.compare_at_price ||
      current_variant.compare_at_price < current_variant.price
    )
      return;

    const amt = this.formatMoney(
      this.current_variant?.compare_at_price - this.current_variant?.price
    );
    // Round down to nearest whole number
    const percentage = Math.floor(
      100 -
        (this.current_variant?.price / this.current_variant?.compare_at_price) *
          100
    );
    return `You save ${percentage}% (${amt})`;
  },
  formatMoney(amount) {
    if (!amount) return;
    return window.cartStrings.currencySymbol + Number(amount / 100)?.toFixed(2);
  },
  setSelectedOptions(index, name) {
    this.selectedOptions[index - 1] = name;
  },
  getVariantFromUrl(id, options) {
    const url = new URL(location);
    const variant = url.searchParams.get("variant");
    if (!variant || variant == id) return;
    const variantObj = this.product.variants.find((v) => v.id == variant);
    this.selectedOptions = [
      variantObj.option1,
      variantObj.option2,
      variantObj.option3,
    ];
  },
  init() {
    // If used on Main product, enable Deep Linking and scroll to featured media
    if (mainProduct) {
      this.$watch("current_variant", (value) => {
        const url = new URL(location); // Change URL history
        url.searchParams.set("variant", value.id);
        history.pushState({}, "", url);
        this.$dispatch("variant:changed"); // Dispatch event for flkty
      });
    }
  },
});
